import apiClient from './client'
import {
  Customer,
  CustomerCreateRequest,
  CustomerPriceRule,
  CustomerPriceRuleCreateRequest,
  CustomerStatus,
  CustomerUpdateRequest,
  PaginatedResponse,
} from '../types'

const ENDPOINT = '/customers'

export const customerApi = {
  getCustomers: async (
    page = 1,
    limit = 20,
    status?: CustomerStatus,
    search?: string,
  ) => {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('limit', limit.toString())
    if (status) params.append('status', status)
    if (search) params.append('search', search)

    const response = await apiClient.get<PaginatedResponse<Customer>>(
      `${ENDPOINT}?${params.toString()}`,
    )
    return response.data
  },

  getCustomer: async (id: string) => {
    const response = await apiClient.get<Customer>(`${ENDPOINT}/${id}`)
    return response.data
  },

  createCustomer: async (data: CustomerCreateRequest) => {
    const response = await apiClient.post<Customer>(ENDPOINT, data)
    return response.data
  },

  updateCustomer: async (id: string, data: CustomerUpdateRequest) => {
    const response = await apiClient.patch<Customer>(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  deleteCustomer: async (id: string) => {
    await apiClient.delete(`${ENDPOINT}/${id}`)
  },

  getPriceRules: async (customerId: string) => {
    const response = await apiClient.get<CustomerPriceRule[]>(`${ENDPOINT}/${customerId}/price-rules`)
    return response.data
  },

  createPriceRule: async (customerId: string, data: CustomerPriceRuleCreateRequest) => {
    const response = await apiClient.post<CustomerPriceRule>(`${ENDPOINT}/${customerId}/price-rules`, data)
    return response.data
  },

  updatePriceRule: async (customerId: string, ruleId: string, data: Partial<CustomerPriceRuleCreateRequest>) => {
    const response = await apiClient.patch<CustomerPriceRule>(`${ENDPOINT}/${customerId}/price-rules/${ruleId}`, data)
    return response.data
  },

  deletePriceRule: async (customerId: string, ruleId: string) => {
    await apiClient.delete(`${ENDPOINT}/${customerId}/price-rules/${ruleId}`)
  },

  listPins: async (customerId: string) => {
    const response = await apiClient.get<CustomerPin[]>(`${ENDPOINT}/${customerId}/pins`)
    return response.data
  },

  createPin: async (customerId: string, data: { name: string; pin: string }) => {
    const response = await apiClient.post<CustomerPin>(`${ENDPOINT}/${customerId}/pins`, data)
    return response.data
  },

  updatePin: async (customerId: string, pinId: string, data: { name?: string; is_active?: boolean }) => {
    const response = await apiClient.patch<CustomerPin>(`${ENDPOINT}/${customerId}/pins/${pinId}`, data)
    return response.data
  },

  deletePin: async (customerId: string, pinId: string) => {
    await apiClient.delete(`${ENDPOINT}/${customerId}/pins/${pinId}`)
  },
}

export interface CustomerPin { id: string; name: string; pin: string; is_active: boolean; created_at: string | null }
